import {
	ActionIconProps as MantineActionIconProps,
	ActionIcon as MantineActionIcon,
	createPolymorphicComponent,
} from '@mantine/core';
import { useUnit } from 'effector-react';
import { ComponentPropsWithoutRef, forwardRef } from 'react';
import { clickSound } from 'shared/lib';

export type ActionIconProps = {
	muted?: boolean;
} & MantineActionIconProps &
	ComponentPropsWithoutRef<'button'>;

export const ActionIcon = createPolymorphicComponent<'button', ActionIconProps>(
	// eslint-disable-next-line react/display-name
	forwardRef<HTMLButtonElement, ActionIconProps>(({ muted, onClick, ...props }, ref) => {
		const playClick = useUnit(clickSound.play);

		return (
			<MantineActionIcon
				{...props}
				ref={ref}
				onClick={(e) => {
					!muted && playClick();
					onClick?.(e);
				}}
			/>
		);
	}),
);

ActionIcon.displayName = 'ActionIcon';
